// Contact section

import L from './leaflet_grayscale';
import { GestureHandling } from 'leaflet-gesture-handling';
import 'leaflet.markercluster/dist/leaflet.markercluster';

L.Map.addInitHook('addHandler', 'gestureHandling', GestureHandling);
const axios = require('axios');


document.addEventListener('DOMContentLoaded', function() {
    // --- Contact form ---
    var contactForm = document.querySelector('#contact-form');
    if (contactForm) {
        document.querySelectorAll('#contact-form input').forEach(input => {
            ['click', 'keypress', 'change'].forEach(evt => {
                input.addEventListener(evt, function() {
                    if (!contactInitTime) contactInitTime = new Date();
                });
            });
        });

        // HP
        setTimeout(function() {
            document.querySelector('#terms').setAttribute('aria-required', 'false');
            document.querySelector('#terms-label').setAttribute('aria-required', 'false');
        }, 5000);

        var contactFormButton = document.querySelector('#contact-form .send-button');
        var contactFormButtonTextSpan = document.querySelector('#contact-form .send-button > span');
        var contactInitTime = null;

        contactForm.addEventListener('submit', function (event) {
            event.preventDefault();

            const formAxios = axios.create();
            formAxios.interceptors.request.use(config => {
                contactFormButton.setAttribute('disabled', 'disabled');
                contactFormButton.setAttribute('aria-disabled', true);
                return config;
            });

            var body = new FormData(contactForm);
            body.append('time', new Date() - contactInitTime);

            function updateValidationMessages(data, request) {
                ['name', 'email', 'subject', 'message'].forEach(id => {
                    var input = contactForm.querySelector('#' + id);
                    var errorSpan = input.nextElementSibling;
                    if (data && id in data) {
                        input.setAttribute('aria-invalid', true);
                        input.classList.add('error');
                        errorSpan.innerHTML = request.response.data[id][0];
                    } else {
                        input.setAttribute('aria-invalid', false);
                        input.classList.remove('error');
                        errorSpan.innerHTML = '&nbsp;';
                    }
                });
            }

            formAxios.post(contactForm.getAttribute('action'), body)
                .then(function (request) {
                    updateValidationMessages(null, request);
                    contactFormButtonTextSpan.innerHTML = contactFormButton.dataset.submitMessageSent;
                })
                .catch(function (request) {
                    if(request.response.data) {
                        updateValidationMessages(request.response.data, request);
                        contactFormButtonTextSpan.innerHTML = contactFormButton.dataset.submitMessageFormError;
                        contactFormButton.removeAttribute('disabled');
                        contactFormButton.setAttribute('aria-disabled', false);
                    } else {
                        contactFormButtonTextSpan.innerHTML = contactFormButton.dataset.submitMessageError;
                    }
                });
        });
    }


    // Distributor map under the contact form
    var mapElement = document.querySelector('#map');

    var map = L.map('map', {
        gestureHandling: true,
    });

    L.tileLayer.grayscale('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
        maxZoom: 19,
        attribution: '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>'
    }).addTo(map);

    var ppIcon = L.icon({
        iconUrl: '/images/pizza-slice-icon.svg',
        iconSize: [30, 30],
        iconAnchor: [15, 15],
        popupAnchor: [0, -15]
    });

    var markers = [];
    var mcg = L.markerClusterGroup();

    function createMapMarkers(service_points) {
        map.removeLayer(mcg);
        markers.forEach(marker => mcg.removeLayer(marker));
        markers = [];

        service_points.forEach(service_point => {
            var marker = L.marker([service_point.latitude, service_point.longitude], {icon: ppIcon});
            mcg.addLayer(marker);
            markers.push(marker);
            marker.bindPopup(`
                <div class="marker-popup">
                    <img class="" src="${service_point.photo}" width=250 height=166 alt="Image représentant le point de service" loading="lazy" />
                    <h4>${service_point.title}</h4>
                    <p>${service_point.descriptioni || '' }</p>
                    <a class="button" href="${service_point.link}" target="_blank"><span>Voir sur Google Maps</span></a>
                </div>
            `).openPopup();
        });
        map.addLayer(mcg);
        map.fitBounds(mcg.getBounds());
    }
    createMapMarkers(JSON.parse(mapElement.dataset.servicePoints));
});
